import { EnumBuilder, type ZodSimplify } from '@mntn-dev/utility-types'
import type { Uuid } from '../unique-id-builder.ts'

/**
 * WARNING - This is admittedly a bit of a hack. FWIW this is all stand-in stuff for a proper CertificationType that hopefully doesn't
 * name collide with anything we do later. I tried to use namings that match our current database certification tags scheme.
 */

/**
 * CertificationKey
 */
export const [CertificationKeys, CertificationKeySchema, CertificationKeyEnum] =
  EnumBuilder(
    'qf-marketplace-certified',
    'mntn-certified',
    'meta-certified',
    'tiktok-certified',
    'tier-1-certified'
  )
export type CertificationKey = ZodSimplify<typeof CertificationKeySchema>

/** This a map to get the Certification key from the WorkRamp Certification ID. */
export const WorkrampCertificationIdToTagKeyMap: Record<
  Uuid,
  CertificationKey
> = {
  // Production Certifications (https://quickframeacademy.com/pages/quickframe-academy)
  '0196c650-c98e-7f2a-875c-8249a8f2959d': 'qf-marketplace-certified', // Named 'QuickFrame Marketplace Onboarding' in WorkRamp
  'c95d2bb6-d77a-11ee-97cf-02ab00d03d4f': 'mntn-certified', // Named 'QuickFrame MNTN Onboarding' in WorkRamp
  '09b5f28e-d75c-11ee-953f-061fddaab711': 'meta-certified', // Named 'QuickFrame Meta Onboarding' in WorkRamp
  '018f9d83-7cea-7026-82e5-1aee98dda2cc': 'tiktok-certified', // Named 'QuickFrame TikTok Onboarding' in WorkRamp

  // Development Certifications in Demo University (https://mntn-hub-4.workramp.io/certifications)
  '01962502-d41b-76e8-bc35-58964e0478a0': 'qf-marketplace-certified',
}

/** This is a reverse map of WorkrampCertificationIdToMap. To get the WorkRamp Certification Id from Certification key. */
export const TagKeyToWorkrampCertificationIdMap: Record<
  CertificationKey,
  Uuid
> = Object.fromEntries(
  Object.entries(WorkrampCertificationIdToTagKeyMap).map(([id, tag]) => [
    tag,
    id,
  ])
) as Record<CertificationKey, Uuid>
